import React, { useEffect, useState } from 'react';
import { Container, Button, Card } from 'react-bootstrap';
import { API_URL } from './config';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';

function SoftworksAdminOpenShift() {
    const navigate = useNavigate();
    const companyId = localStorage.getItem('company_id'); 
    const userId = localStorage.getItem('user_id'); 
    const branchId = localStorage.getItem('branch_id');
    const [branchDetails, setBranchDetails] = useState(null);
    const [companyDetails, setCompanyDetails] = useState(null);
    const [username, setUsername] = useState(localStorage.getItem('userName'));
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const existingShiftDetails = localStorage.getItem('shiftDetails');
        if (existingShiftDetails) {
            const shiftDetails = JSON.parse(existingShiftDetails);
            navigate('/SoftworksStore', { state: { shiftDetails } });
        }

        // Fetch branch and company details
        fetchBranchDetails();
        fetchCompanyDetails();

        // Log fetched details from local storage
        console.log('Fetched from local storage:', {
            companyId,
            branchId,
            userId,
            username,
        });
    }, [navigate]);

    console.log("Branch redu",branchId);

    const fetchBranchDetails = async () => {
        try {
            const response = await fetch(`${API_URL}/branch/${branchId}`);
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();
            if (Array.isArray(data) && data.length > 0) {
                setBranchDetails(data[0]); 
                console.log('Branch Details:', data[0]); 
            } else {
                console.error('No branch data found');
            }
        } catch (error) {
            console.error('Error fetching branch details:', error);
        }
    };

    const fetchCompanyDetails = async () => {
        try {
            const response = await fetch(`${API_URL}/companysetup/${companyId}`);
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();
            setCompanyDetails(data);
            console.log('Company Details:', data); // Log the company details
        } catch (error) {
            console.error('Error fetching company details:', error);
        }
    };

    const handleOpenShift = async () => {
        setLoading(true);
        const dateTimeOpen = new Date().toISOString();
        const shiftComment = "Opened by " + username;
        const data = {
            company_id: companyId,
            branch_id: branchId,
            operator_id: userId,
            shift_status: "open",
            date_time_open: dateTimeOpen,
            date_time_close: '',
            shift_comment: shiftComment,
            syncid: 'abc123',
        };

        try {
            const response = await fetch(`${API_URL}/shift`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const result = await response.json();

            // Store the returned shift ID
            const shiftId = result.insertedId; // Adjusted to get the inserted ID
            localStorage.setItem('shiftId', shiftId);
            localStorage.setItem('dateTimeOpen', dateTimeOpen);
            localStorage.setItem('branchId', data.branch_id);

            const shiftDetails = {
                shift_id: shiftId, // Use the returned shift ID
                company_id: companyId,
                branch_id: data.branch_id,
                branch_name: branchDetails ? branchDetails.branch_name : '',
                operator_id: userId,
                date_time_open: dateTimeOpen,
                date_time_close: '',
                shift_comment: shiftComment,
                syncid: 'abc123',
            };
            localStorage.setItem('shiftDetails', JSON.stringify(shiftDetails));

            // Log shift details to the console
            console.log('Shift Details:', shiftDetails);

            await Swal.fire({
                title: 'Success!',
                text: 'Shift opened successfully!',
                icon: 'success',
                confirmButtonText: 'OK',
                confirmButtonColor: '#6f42c1',
            });

            navigate('/SoftworksStore', {
                state: {
                    shiftDetails,
                    companyName: companyDetails ? companyDetails.name : '',
                    branchName: branchDetails ? branchDetails.branch_name : '',
                    operatorName: username,
                }
            });

        } catch (error) {
            console.error('Error opening shift:', error);
            Swal.fire({
                title: 'Error',
                text: 'Failed to open shift. Please try again.',
                icon: 'error',
                confirmButtonColor: '#6f42c1',
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-vh-100 bg-light py-5" style={{ background: 'linear-gradient(135deg, #f5f5f5 0%, #e9ecef 100%)' }}>
            <Container>
                <motion.div
                    initial={{ opacity: 0, y: -20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5 }}
                >
                    <header className="text-center mb-5">
                        <h4 className="display-4 text-purple fw-bold" style={{ color: '#6f42c1' }}>
                            Softworks Admin
                        </h4>
                        <h5 className="h3 text-muted">Open Shift</h5>
                    </header>

                    <motion.div
                        initial={{ opacity: 0, scale: 0.95 }}
                        animate={{ opacity: 1, scale: 1 }}
                        transition={{ delay: 0.2, duration: 0.5 }}
                    >
                        <Card className="shadow-lg mx-auto" style={{ maxWidth: '400px' }}>
                            <Card.Header className="bg-purple text-white text-center py-2" style={{ backgroundColor: '#6f42c1' }}>
                                <h5 className="mb-0">Confirm Shift Details</h5>
                            </Card.Header>
                            <Card.Body className="p-4">
                                <div className="details-container">
                                    <div className="detail-item mb-3 p-3 border-bottom">
                                        <label className="text-muted mb-1">Name</label>
                                        <p className="h5 mb-0">{username}</p>
                                    </div>
                                    <div className="detail-item mb-3 p-3 border-bottom">
                                        <label className="text-muted mb-1">Company</label>
                                        <p className="h5 mb-0">{companyDetails ? companyDetails.name : 'Loading...'}</p>
                                    </div>
                                    <div className="detail-item mb-4 p-3 border-bottom">
                                        <label className="text-muted mb-1">Branch</label>
                                        <p className="h5 mb-0">{branchDetails ? branchDetails.branch_name : 'Loading...'}</p>
                                    </div>

                                    <div className="text-center mt-2">
                                        <Button
                                            size="lg"
                                            className="px-5 py-1"
                                            style={{
                                                backgroundColor: '#6f42c1',
                                                border: 'none',
                                                transition: 'all 0.3s ease'
                                            }}
                                            onClick={handleOpenShift}
                                            disabled={!branchId || loading}
                                        >
                                            {loading ? (
                                                <>
                                                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                    Opening Shift...
                                                </>
                                            ) : (
                                                'Open Shift'
                                            )}
                                        </Button>
                                    </div>
                                </div>
                            </Card.Body>
                        </Card>
                    </motion.div>
                </motion.div>
            </Container>

            <style jsx>{`
                .detail-item {
                    transition: all 0.3s ease;
                    border-radius: 8px;
                }
                .detail-item:hover {
                    background-color: rgba(111, 66, 193, 0.05);
                }
                .btn:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 4px 12px rgba(111, 66, 193, 0.2);
                    background-color: #5a32a3 !important;
                }
                .card {
                    border-radius: 15px;
                    border: none;
                }
                .card-header {
                    border-radius: 15px 15px 0 0 !important;
                }
            `}</style>
        </div>
    );
}

export default SoftworksAdminOpenShift;